import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Params } from '@angular/router';
import { ApiErrorService } from '@app/shared/services/api-error.service';
import { ToastService } from '@app/shared/services/shared/toast.service';
import { RefreshAccessTokenService } from '@app/shared/services/token-refresh-coordinator.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthEndpoints } from '../services/http/auth-http.service';
import { HANDLE_ERROR_LOCALLY } from './handle-error-locally.context';

export function httpErrorInterceptor(req: HttpRequest<Params>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (req.url.includes(AuthEndpoints.LOGIN)) {
          return throwError(() => error);
        }
        const isRefreshTokenRequest = req.url.includes(AuthEndpoints.REFRESH_ACCESS_TOKEN);
        if (!isRefreshTokenRequest) {
          return injector
            .get(RefreshAccessTokenService)
            .refreshOrWait()
            .pipe(switchMap(() => next(req)));
        }
      }

      if (req.context.get(HANDLE_ERROR_LOCALLY)) {
        return throwError(() => error);
      }

      const message = injector.get(ApiErrorService).getMessage(error);
      const toastService = injector.get(ToastService);
      if (message) {
        toastService.error(message);
      } else {
        toastService.error(injector.get(TranslateService).instant('toasts.operation-failed'));
      }
      return throwError(() => error);
    })
  );
}
